export default 
  `
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAovJjOjuezMevI8lGj8ez
puCFbWJENWH+jki1roZolNEy2PEZdElJr+9uMQKa+NLaT5qyE/gPThbSuSHssIXB
dqjEotEsQBzpYEqa/T7suEX0dmdEdzzxWk6J4fUZptfACVUYbNcPln8xCKSOu8CC
WuqL1FR/h7m45Etl7erYcN6HebaWlUF1z2Nitim8+PcE5sx/0Tab298/U0GZWmfv
S/S4FXYGkST97rFWy+VxwCHyNblpHw+rQYegOINmBkTxAmy9UPGw37QKswEX3DWZ
FTI5XDiiBQhSlLgsX3iqa4lapBt+UM6ryYP8nFqLrr2KrCud6SfGl1ixSQx/N55V
SxRa/ZAfnJcOHjKQCVb+gzEZqkGkh5kDoR7a4f/qdBEm4Dvs7xSUJPEUZO2jvgHw
g+FU1Cz6iTbs3uz9lsgqVYm9SeW6N3ZyY6GVF6j9uy+r0kkat8zTjPBesml0lmbH
BUjpxUpnwBuX0HAlmOSNeXyWYao12+azf474Pm9p89dFlh8zGdNRcL3QBK0M7Ymk
p75+nAPHdP0GofcSElpvarcg8sRoXAjh532N3Je/qE209s9BdSeFTaLeBW0K9knr
ymOdRsNSdCbiObCha0CyOZYvv1hYm2X9gau8Wpill1ZkhGef9gbI+nRbw/bdHwEx
T5tAsDz0zsS5rWFOoqzal+UCAwEAAQ==
`
